import { Badge } from "@drs-ops/ui";
import { MapPin, Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import type { EnrichedHotel } from "@/types/tripPlanner";

export interface HotelCardProps {
  hotel: EnrichedHotel;
}

export function HotelCard({ hotel }: HotelCardProps): React.ReactElement {
  const tierLabel = hotel.tier ?? hotel.comparable_tier;
  return (
    <Card>
      <CardContent className="flex flex-col gap-2 p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="font-medium">{hotel.name}</div>
          {hotel.hilton_brand && <Badge variant="secondary">{hotel.hilton_brand}</Badge>}
        </div>
        {tierLabel && <div className="text-xs text-muted-foreground capitalize">{tierLabel.replace(/-/g, " ")}</div>}
        <div className="text-sm text-muted-foreground">{hotel.address}</div>
        <div className="text-xs text-muted-foreground">
          {hotel.distance_miles.toFixed(1)} mi · ★ {hotel.rating ?? "—"} ({hotel.user_ratings_total ?? 0})
        </div>
        <div className="mt-1 flex gap-2 text-sm">
          {hotel.url && (
            <a
              href={hotel.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:underline"
            >
              <MapPin className="h-3 w-3" /> Maps
            </a>
          )}
          {hotel.phone && (
            <a
              href={`tel:${hotel.phone.replace(/[^\d+]/g, "")}`}
              className="inline-flex items-center gap-1 text-primary hover:underline"
            >
              <Phone className="h-3 w-3" /> {hotel.phone}
            </a>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
